package alltravelagents

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.getPaginationData
import com.essntl.features.travelagent.domain.model.TravelAgentModel
import com.essntl.features.travelagent.domain.repository.TravelAgentRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update

class AllTravelAgentsViewModel(
    private val travelAgentRepository: TravelAgentRepository,
    private val state: MutableStateFlow<AllTravelAgentsState>,
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {

    init {
        getNextTravelAgentPage()
    }

    fun onEvent(event: AllTravelAgentsEvent) {
        when (event) {
            is AllTravelAgentsEvent.LoadTravelAgents -> getNextTravelAgentPage(travelAgent = event.travelAgent)
            is AllTravelAgentsEvent.SearchTravelAgent -> {
                state.value = state.value.copy(getAllTravelAgents = PaginationState(query = event.query))
                getNextTravelAgentPage()
            }
        }
    }

    private fun getNextTravelAgentPage(
        travelAgent: TravelAgentModel? = null,
        query: String = state.value.getAllTravelAgents.query,
    ) {
        if (travelAgent != null) {

            val newTravelAgent = state.value.getAllTravelAgents.data.find {
                it.id == travelAgent.id
            }

            if (newTravelAgent != null) {
                // Edit travel agent
                state.update {
                    it.copy(
                        getAllTravelAgents = it.getAllTravelAgents.copy(
                            data = it.getAllTravelAgents.data.map { ta ->
                                if (ta.id == travelAgent.id) {
                                    travelAgent
                                } else {
                                    ta
                                }
                            },
                        ),
                    )
                }
            } else {
                // Add new travel agent
                onEvent(AllTravelAgentsEvent.SearchTravelAgent(""))
            }
        } else {
            getPaginationData(
                getData = {
                    val nextPage = state.value.getAllTravelAgents.loadedPages + 1L
                    travelAgentRepository.getAll(page = nextPage, query = query)
                },
                getState = { state.value.getAllTravelAgents },
                setState = {
                    state.value = state.value.copy(getAllTravelAgents = it)
                },
            )
        }
    }
}